import PaperBase from '../../Paper/PaperBase';
import { Typography } from '@mui/material';

import LearningGrowthIcon from './LearningGrowthIcon';

const LearningGrowthCard = ({
  id,
  className = '',
  backgroundColor,
  currentCurriculum,
  color,
  step,
  lc,
  level,
  onClick,
  findLG,
  isLoading,
  direction = 'row',
  size,
  lgMin,
  lgMax,
  generalPosition
}) => {
  // const width = size;
  // const styleSize =  { height: size, width: size } ;
  const width = direction === 'row' ? 'auto' : size;
  const styleSize = direction === 'row' ? { height: size, width: size } : { };

  return (
    <PaperBase
      id={id}
      backgroundColor={backgroundColor}
      color={color}
      className={[
        ' text-ellipsis flex-col relative justify-between w-full',
        step?.definition ? '' : 'bg-lines',
        direction === 'row' ? 'w-full' : 'min-w-200px w-full',
        className
      ].join(' ')}
      onClick={onClick}
      children={
        <>
          {/* <div className={`absolute inset-0 `}> */}
          <div className={`absolute inset-0 ${direction === 'column' && step.definition ? 'bg-loading' : ''}`} style={{ width }}>
            <LearningGrowthIcon
              backgroundColor={backgroundColor}
              currentCurriculum={currentCurriculum}
              step={step}
              lc={lc}
              level={level}
              findLG={findLG}
              isLoading={isLoading}
              direction={direction}
              size={size}
              generalPosition={generalPosition}
              lgMin={lgMin}
              lgMax={lgMax}
            />
          </div>
          {direction === 'row' ? (
            <></>
          ) : (
            <Typography
              className='text-ellipsis text-sm'
              style={{ paddingLeft: width, minHeight: `calc(${width}px + 1rem)` }}
            >
              {step?.definition}
            </Typography>
          )}
        </>
      }
      style={styleSize}
    />
  );
};

export default LearningGrowthCard;
